export enum EPromoCode {
    percentage = "Відсоток на баланс",
    amount = "Сума на баланс"
}